import { motion } from 'framer-motion';
import { FaMobile, FaCode, FaCloud, FaGamepad } from 'react-icons/fa';

const Skills = () => {
  const skills = [
    { name: 'Flutter', level: 85, experience: '1 Year', icon: FaMobile },
    { name: 'HTML/CSS', level: 90, experience: '2+ Years', icon: FaCode },
    { name: 'JavaScript', level: 80, experience: '1.5 Years', icon: FaCode },
    { name: 'Node.js', level: 70, experience: '1 Year', icon: FaCode },
    { name: 'Azure', level: 70, experience: '8 Months', icon: FaCloud },
    { name: 'Firebase', level: 75, experience: '8 Months', icon: FaCloud },
    { name: 'Unity', level: 75, experience: '10 Months', icon: FaGamepad },
    { name: 'C#', level: 70, experience: '10 Months', icon: FaGamepad },
  ];

  return (
    <section id="skills" className="py-20 bg-gray-900">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            My <span className="text-gradient">Skills</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            A comprehensive overview of my technical expertise and experience across various technologies.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {skills.map((skill, index) => (
            <motion.div
              key={skill.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.02, y: -5 }}
              viewport={{ once: true }}
              className="card"
            >
              <div className="flex items-center gap-4 mb-4">
                <div style={{
                  width: '3rem',
                  height: '3rem',
                  background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
                  borderRadius: '0.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <skill.icon style={{ fontSize: '1.25rem', color: 'white' }} />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white">{skill.name}</h3>
                  <p className="text-sm text-gray-400">{skill.experience}</p>
                </div>
              </div>

              <div className="mb-2">
                <div className="flex justify-between text-sm text-gray-400 mb-1">
                  <span>Proficiency</span>
                  <span>{skill.level}%</span>
                </div>
                <div style={{
                  width: '100%',
                  height: '0.5rem',
                  background: '#374151',
                  borderRadius: '0.25rem',
                  overflow: 'hidden'
                }}>
                  <motion.div
                    initial={{ width: 0 }}
                    whileInView={{ width: `${skill.level}%` }}
                    transition={{ duration: 1, delay: index * 0.1 + 0.5 }}
                    viewport={{ once: true }}
                    style={{
                      height: '100%',
                      background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
                      borderRadius: '0.25rem'
                    }}
                  />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
